import * as React from 'react';
import { Field } from '../dynamic-input-field/DynamicInputField';

import style from './DynamicSelectionField.module.css';

type DynamicInputFieldProps = {
    api: any,
    field: Field,
}

const DynamicSelectionField = (props: DynamicInputFieldProps) => {
    const dataStore = props.api.getDataStore(props.field);
    const [isValid, setValid] = React.useState(true);

    const handleOnChange = (e: any) => {
        dataStore.put(props.field.name, e.target.value);
        props.field.validation?.();
    };

    const validationStyling = isValid ? style.valid : style.invalid;

    props.field.validation = () => {
        if (!dataStore.get(props.field.name) || dataStore.get(props.field.name).trim().length == 0) {
            setValid(!props.field.required);
            return !props.field.required;
        }
        setValid(true);
        return true;
    };

    return (
        <div id={style.container}>
            <div id={style.text}>{props.field.text}{props.field.required ? '*' : ''}</div>
            <select id={style.selection} className={validationStyling} onChange={handleOnChange} name={props.field.name} defaultValue={dataStore.get(props.field.name)}>
                <option key={'padding' + '_' + props.field.name + '_' + props.field.type}></option>
                {
                    props.field.metadata?.map((field: any, index: number) => {
                        return <option key={index + '_' + props.field.name + '_' + field.name + '_' + field.type} value={field.FormQuestionFieldID}>{field.Name}</option>
                    })
                }
            </select>
        </div>
    )
}

export default DynamicSelectionField;